// extracted by mini-css-extract-plugin
module.exports = {"title":"Report_title__2gUh7","text":"Report_text__3wEIc","info":"Report_info__37jQ3","input":"Report_input__FB1nQ","btns":"Report_btns__3BRMJ","button":"Report_button__1-W1d"};